import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

// Renders /privacy or /terms using the i18n blocks `privacy` / `terms`
export default function LegalPage({ kind }) {
  const { t } = useLang();
  const block = kind === "privacy" ? t.privacy : t.terms;

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
        · kuryarti / {kind}
      </div>
      <h1 className="mt-3 font-mono font-bold tracking-tighter text-3xl lg:text-4xl text-[#0a0a0a]">
        {block.title}
      </h1>
      <p className="mt-2 font-sans text-sm text-[#8a8a8a]">{block.updated}</p>

      <div className="mt-10 space-y-8">
        {block.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-mono font-bold text-lg text-[#0a0a0a] uppercase tracking-[0.12em]">
              <span className="text-[#ff006e]">{String(i + 1).padStart(2, "0")} /</span> {s.h}
            </h2>
            <p className="mt-3 font-sans text-[15px] leading-relaxed text-[#333333] whitespace-pre-line">{s.b}</p>
          </section>
        ))}
      </div>

      <div className="mt-14 pt-8 border-t border-dashed border-[#e5e5e5]">
        <Link
          to="/"
          className="font-mono text-xs uppercase tracking-[0.2em] text-[#0a0a0a] underline underline-offset-4 hover:text-[#ff006e] transition-colors"
        >
          ← {t.reset.back}
        </Link>
      </div>
    </div>
  );
}
